import axiosInstance from "../../../shared/api/axiosInstance";
import { configReq } from "../../../shared/lib/functions";
import { getGatewaySettings } from "./payments";
import { normalizePaymentResponse } from "./payment-response";

const options = (token) => ({ ...configReq(token), timeout: 25000 });
const uuid = (id) => /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id);
export async function requestSandboxRefund(token, orderId, operationId) {
  if (!uuid(orderId) || !uuid(operationId)) throw new Error("sandbox-refund-id");
  const settings = await getGatewaySettings(token);
  if (!settings.testMode || !settings.testKeyConfigured) throw new Error("sandbox-not-ready");
  const order = normalizePaymentResponse((await axiosInstance.get(`admin/v2/PaymentOrders/${orderId}`, options(token))).data);
  if (order.testMode !== true || order.currency !== "EUR" || order.amountMinor !== 100) throw new Error("sandbox-refund-order");
  const payload = { id: operationId, amountMinor: 100, description: "Digikraam sandbox refund verification" };
  const responses = await Promise.all([1, 2].map(async () => {
    try {
      const response = await axiosInstance.post(`admin/v2/PaymentRefunds/${orderId}`, payload, options(token));
      return { http: response.status, data: normalizePaymentResponse(response.data) };
    } catch (error) { return { http: error.response?.status || 0 }; }
  }));
  const result = responses.find((response) => response.http === 200)?.data;
  return { id: operationId, status: result?.status || "needs_refresh", http: responses.map((response) => response.http).join(" / ") };
}
export async function refreshSandboxRefund(token, id) {
  if (!uuid(id)) throw new Error("sandbox-refund-id");
  const response = await axiosInstance.post(`admin/v2/PaymentRefunds/${id}/refresh`, {}, options(token));
  return { id, status: normalizePaymentResponse(response.data).status };
}
